/**
 * Created by Rodrigo Quesada on 16/01/17.
 */
import {Injectable} from '@angular/core';
import {RepeatableScreensManagerDeps} from '../../../shared/step/repeatable-screen-manager.class';
import {InternshipService} from '../../../../domain/model/education/internship/internship.service';
import {RepeatableUserModelScreensManager} from '../../../../components/sections/repeatable/repeatable-user-model-screens-manager.service';

@Injectable()
export class InternshipScreensManager extends RepeatableUserModelScreensManager {

    constructor(rsmm: RepeatableScreensManagerDeps, protected readonly _modelService: InternshipService) {
        super(rsmm);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/education/steps/internship/internship-screens-manager.service.ts